module.exports = bamShared.sessionUtil;